import { LitElement } from "lit";
import { customElement } from "lit/decorators.js";

@customElement("ehm-breadcrumbs")
export class EhmBreadcrumbs extends LitElement {
  private mediaQuery = window.matchMedia("(max-width: 450px)");
  private expanded = false;
  private originalItems: HTMLElement[] = [];

  createRenderRoot() {
    return this;
  }

  connectedCallback() {
    super.connectedCallback();
    this.mediaQuery.addEventListener("change", this.handleResize);
    queueMicrotask(() => this.initialize());
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.mediaQuery.removeEventListener("change", this.handleResize);
  }

  private handleResize = () => {
    this.expanded = false;
    this.updateBreadcrumbs();
  };

  private initialize() {
    const ol = this.querySelector("ol");
    if (!ol) return;

    this.originalItems = Array.from(ol.children) as HTMLElement[];
    this.updateBreadcrumbs();
  }

  private updateBreadcrumbs() {
    const ol = this.querySelector("ol");
    if (!ol) return;

    ol.innerHTML = "";
    this.originalItems.forEach((item) => {
      item.hidden = false;
    });

    const isMobile = this.mediaQuery.matches;
    const count = this.originalItems.length;

    if (!isMobile || count <= 2 || this.expanded) {
      // Render all
      this.originalItems.forEach((item) => ol.appendChild(item));
      return;
    }

    // Mobile + truncated
    const first = this.originalItems[0];
    const last = this.originalItems[count - 1];

    ol.appendChild(first);
    ol.appendChild(this.createEllipsisItem(first.className));
    ol.appendChild(last);
  }

  private createEllipsisItem(className: string): HTMLLIElement {
    const li = document.createElement("li");
    if (className) li.classList.add(className);

    const button = document.createElement("button");
    button.type = "button";
    button.textContent = "…";
    button.setAttribute("aria-label", "Visa hela brödsmulan");
    button.setAttribute("aria-expanded", "false");
    button.classList.add("breadcrumbs-reveal-button");

    button.addEventListener("click", () => {
      this.expanded = true;
      button.setAttribute("aria-expanded", "true");
      this.updateBreadcrumbs();
    });

    li.appendChild(button);
    return li;
  }
}